import React from "react"
import ReactDOM from "react-dom"
import ServiceLinkCardContainer from "./service-link-card-container-component"

export default class ServiceLinkCardContainerModule {
  constructor(elem) {
    const self = this
    self.elem = elem
    self.modelJson = elem.dataset.modelJson && JSON.parse(elem.dataset.modelJson)
    this.init()
    return self
  }

  init() {
    const self = this
    ReactDOM.unmountComponentAtNode(self.elem)
    ReactDOM.render(<ServiceLinkCardContainer {...self.modelJson} />, self.elem)
  }
}
